import apiService from './ApiService';

class ProfesorParticularApiService {
  async getProfesoresParticulares() {
    return apiService.get('/profesores-particulares');
  }

  async getProfesorParticularById(id) {
    return apiService.get(`/profesores-particulares/${id}/admin`);
  }

  async createProfesorParticular(payload) {
    return apiService.post('/profesores-particulares', payload);
  }

  async updateProfesorParticular(id, payload) {
    return apiService.put(`/profesores-particulares/${id}`, payload);
  }

  async updateProfesorParticularConfiguracion(id, payload) {
    return apiService.put(`/profesores-particulares/${id}/configuracion`, payload);
  }

  async updateProfesorParticularActivo(id, activo) {
    return apiService.put(`/profesores-particulares/${id}/activo`, { activo });
  }

  async getProfesores(id) {
    const response = await apiService.get(`/profesores-particulares/${id}/profesores`);
    const profesores = response?.profesores || response?.Profesores || response?.data || response || [];
    return Array.isArray(profesores) ? profesores : [];
  }

  async createProfesor(id, payload) {
    return apiService.post(`/profesores-particulares/${id}/profesores`, payload);
  }

  async updateProfesor(id, profesorId, payload) {
    return apiService.put(`/profesores-particulares/${id}/profesores/${profesorId}`, payload);
  }

  async updateProfesorActivo(id, profesorId, activo) {
    return apiService.put(`/profesores-particulares/${id}/profesores/${profesorId}/activo`, { activo });
  }

  async resetProfesorPassword(id, profesorId) {
    return apiService.put(`/profesores-particulares/${id}/profesores/${profesorId}/reset-password`);
  }
}

const profesorParticularApiService = new ProfesorParticularApiService();

export default profesorParticularApiService;
